import { render, staticRenderFns } from "./LedgersPage.vue?vue&type=template&id=5a4e5352&scoped=true"
import script from "./LedgersPage.vue?vue&type=script&lang=js"
export * from "./LedgersPage.vue?vue&type=script&lang=js"
import style0 from "./LedgersPage.vue?vue&type=style&index=0&id=5a4e5352&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4e5352",
  null
  
)

export default component.exports